export * from './import-export.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/import-export/import-export/index.ts